import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Async thunk to fetch brand details
export const fetchBrandDetails = createAsyncThunk(
  'brandDetails/fetchBrandDetails',
  async (brandId, { getState, rejectWithValue }) => {
    try {
      const { user } = getState();
      const token = user.token;
      
      console.log('fetchBrandDetails called with brandId:', brandId);
      console.log('User token:', token ? 'Token exists' : 'No token');
      
      if (!token) {
        throw new Error('No authentication token found');
      }

      if (!brandId) {
        throw new Error('Brand ID is required');
      }

      const url = `${API_BASE_URL}/brands/${brandId}/details/`;
      console.log('Making API call to:', url);

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      console.log('API response status:', response.status);

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error('Authentication failed - please log in again');
        } else if (response.status === 403) {
          throw new Error('Access forbidden - insufficient permissions');
        } else if (response.status === 404) {
          throw new Error('Brand not found');
        }
        { const e = new Error(`HTTP ${response.status}`); e.status = response.status; throw e; }
      }

      const data = await response.json();
      console.log('API response data:', data);
      return data;
    } catch (error) {
      console.error('fetchBrandDetails error:', error);
      return rejectWithValue(error.message);
    }
  }
);

const brandDetailsSlice = createSlice({
  name: 'brandDetails',
  initialState: {
    brand: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearBrandDetails: (state) => {
      state.brand = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBrandDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBrandDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.brand = action.payload;
      })
      .addCase(fetchBrandDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearBrandDetails } = brandDetailsSlice.actions;
export default brandDetailsSlice.reducer;
